import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    public canActivate() {
        if (this.authenticationService.checkLoginState() == true) {
            return true;
        } else {
            this.router.navigate(['authentication/login']);
            return false;
        }
    }
}
